<template>
   <v-card class="mx-auto" :max-width="width">
      <v-toolbar color="primary">
         <v-toolbar-title class="white--text text-center"
            >HISTORIAL DE ESTADOS</v-toolbar-title
         >
         <v-spacer></v-spacer>
      </v-toolbar>

      <v-list two-line>
         <v-list>
            <template v-if="estados.length > 0">
               <template v-for="(item, index) in estados">
                  <v-list-item :key="item.id">
                     <v-container class="fluid">
                        <v-list-item-content>
                           <v-list-item-title
                              class="font-weight-bold"
                              v-text="item.estadoCaso"
                           ></v-list-item-title>

                           <v-list-item-subtitle
                              v-text="item.fecha"
                           ></v-list-item-subtitle>

                           <v-list-item-subtitle
                              v-text="item.user"
                           ></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                           <v-list-item-action-text
                              v-text="item.hora"
                           ></v-list-item-action-text>
                        </v-list-item-action>
                     </v-container>
                  </v-list-item>

                  <v-divider
                     v-if="index < estados.length - 1"
                     :key="index"
                  ></v-divider>
               </template>
            </template>
            <template v-else>
               <h4 class="text-center">Sin historial</h4>
            </template>
         </v-list>
      </v-list>
   </v-card>
</template>

<script>
export default {
   props: {
      width: {
         type: Number,
         default: 500
      },
      estados: {
         type: Array,
         default: function () {
            return []
         }
      }
   },
   data: () => ({})
}
</script>

<style lang="scss" scoped></style>
